import { render, staticRenderFns } from "./superviseOil.vue?vue&type=template&id=4f5a07cf&scoped=true&"
import script from "./superviseOil.vue?vue&type=script&lang=js&"
export * from "./superviseOil.vue?vue&type=script&lang=js&"
import style0 from "./superviseOil.vue?vue&type=style&index=0&id=4f5a07cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a07cf",
  null
  
)

export default component.exports